import { render, staticRenderFns } from "./SchoolListsCourseIndex.vue?vue&type=template&id=c808e006"
import script from "./SchoolListsCourseIndex.vue?vue&type=script&lang=js"
export * from "./SchoolListsCourseIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports